import { ProductIntroduction } from './ProductIntroduction';

/* What the page will be, drawn before it can be. The headline needs nothing from the server,
   so it is the real one; the ask card is its outline, at its own size, so nothing moves when
   the form arrives. */
export function LoadingPreview() {
  return <><ProductIntroduction />
    <div className="workspace"><div className="main-column">
      <section className="ask-card loading-card" role="status" aria-label="Getting things ready">
        <div className="eyebrow">YOUR NEXT UNIT</div>
        <div className="skeleton skeleton-question" />
        <div className="skeleton skeleton-line" />
        <div className="skeleton skeleton-field" />
        <div className="profile-grid"><div className="skeleton skeleton-select" /><div className="skeleton skeleton-select" /></div>
        <div className="form-footer"><div className="skeleton skeleton-button" /><span className="quota">Getting things ready…</span></div>
      </section>
    </div></div></>;
}
